export default "__VITE_ASSET__3339f30b__"